/**
 * Encode a string as Base64, including Unicode / non-Latin1 characters.
 * Native btoa() only accepts Latin1 and throws on typical localised URLs.
 *
 * @param {string} value
 * @returns {string} Base64-encoded representation of the input string, or empty string when value is nullish.
 */
export function encodeBase64Unicode(value) {
  if (value == null) {
    return '';
  }

  const bytes = new TextEncoder().encode(String(value));
  let binary = '';
  const chunkSize = 0x8000;

  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
  }

  return btoa(binary);
}
